import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../Config';
import { ContentsReturn } from '../Interfaces/ContentsReturn';

const emptyContentsReturn: ContentsReturn = {
    id: '',
    page: '',
    heading: '',
    content: '',
    clientID: 0
};

type GuidMap = { [key: string]: string };
type DynamicContents = { [key: string]: ContentsReturn };

export const useWebContents = (guids: GuidMap, pageName: string): DynamicContents => {
    const [contents, setContents] = useState<DynamicContents>(() => {
        // Initialize all keys with emptyContentsReturn
        const initial: DynamicContents = {};
        Object.keys(guids).forEach(key => {
            initial[key] = emptyContentsReturn;
        });
        return initial;
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get<ContentsReturn[]>(`${config.apiUrl}/Contents/${config.tenant}/tenant/${pageName}`);
                const all = res.data;
                const newContents: DynamicContents = {};
                Object.entries(guids).forEach(([key, id]) => {
                    newContents[key] = all.find(item => item.id === id) ?? emptyContentsReturn;
                });
                setContents(newContents);
            } catch (error) {
                console.error('Error fetching home content:', error);
            }
        };
        fetchData();
    }, [JSON.stringify(guids)]);

    return contents;
};